// src/utils/ChartFunctions.tsx
import dayjs from "dayjs";

interface Lead {
  createdAt: string;
  status: string | null;
}

/**
 * Converts leads data into Google Charts compatible format.
 * @param leads - Array of lead objects
 * @param monthsCount - Number of months to include (default = 4)
 * @returns chartData for Google Charts
 */
export function getChartData(leads: Lead[], monthsCount: number = 4) {
  // Get the last `monthsCount` months dynamically
  const months: string[] = [];
  for (let i = monthsCount - 1; i >= 0; i--) {
    months.push(dayjs().subtract(i, "month").format("MMM"));
  }

  const monthMap: Record<string, { leads: number; contacts: number }> = {};
  months.forEach((m) => {
    monthMap[m] = { leads: 0, contacts: 0 };
  });

  leads.forEach((lead: any) => {
    const month = dayjs(lead.createdAt).format("MMM");
    if (monthMap[month]) {
      if (lead.leadType === 0) {
        monthMap[month].leads += 1;
      }
      if (lead.leadType === 1) {
        monthMap[month].contacts += 1;
      }
    }
  });

  const chartData: (string | number)[][] = [["Month", "Leads", "Contacts"]];
  months.forEach((m) => {
    chartData.push([m, monthMap[m].leads, monthMap[m].contacts]);
  });

  return chartData;
}
export function getPieChartData(leads: Lead[]) {
  const statusMap: Record<string, number> = {};

  leads.forEach((lead) => {
    const status = lead.status || "Unknown";
    statusMap[status] = (statusMap[status] || 0) + 1;
  });

  const pieData: (string | number)[][] = [["Status", "Count"]];
  Object.entries(statusMap).forEach(([status, count]) => {
    pieData.push([status, count]);
  });

  return pieData;
}